import { Component } from '@angular/core';
import { UniTextComponent } from '../uni-text/uni-text.component';

@Component({
  selector: 'uni-text-subheader',
  templateUrl: './uni-text-subheader.component.html',
  styleUrls: ['./uni-text-subheader.component.scss'],
})
export class UniTextSubheaderComponent extends UniTextComponent {}
